import base from './api.js';

const mainURL = 'https://www.stage.cop.inlearno.info/';
export default {
  ...base,
  mainURL,
  baseURL: `${mainURL}api/`,
};



// WEBPACK FOOTER //
// ./src/config/http/api.dev.js